@if ((sessionId && !chargingSession) || (chargingSession && !chargingSession.terminated)) {
  <div
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'session.a11y.dialog-title' | translate"
    class="overlay"
    [ngClass]="{ expanded: expanded() }"
  >
    @if (!expanded()) {
      <div class="expansion-toggle" (click)="toggleOverlay(true)" cdkFocusInitial genericButton>
        <p>
          {{
            (chargingSession?.status ? 'session.status.' + chargingSession?.status : null) ||
              'session.status.WAITING' | translate
          }}
          ({{ chargingSession?.duration ? chargingSession?.duration.substr(0, 4) : '00:00' }})
          <eop-icon
            [identifier]="'arrow-down'"
            class="toggle-overlay-icon"
            aria-hidden="true"
          ></eop-icon>
        </p>
      </div>
    }
    @if (expanded()) {
      <div #focusTrapElement>
        <div
          class="expansion-toggle expanded"
          (click)="toggleOverlay(false)"
          cdkFocusInitial
          genericButton
        >
          <p>
            {{ 'global.hide' | translate }}
            <eop-icon
              [identifier]="'arrow-down'"
              class="toggle-overlay-icon"
              aria-hidden="true"
            ></eop-icon>
          </p>
        </div>
        <div class="header-text" aria-live="polite" aria-atomic="true">
          <h1>
            {{
              (chargingSession?.status !== 'ERROR'
                ? chargingSession?.status
                  ? 'session.status.' + chargingSession.status
                  : null
                : 'session.status.' + chargingSession?.detailedStatus) || 'session.status.WAITING'
                | translate
            }}
          </h1>
        </div>
        <div class="battery-background" aria-hidden="true">
          <div class="battery-image">
            <svg
              width="100px"
              height="240px"
              viewBox="0 0 100 240"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->
              <title>illu_battery_outline_white</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g
                id="Artboard"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(-3363.000000, -995.000000)"
              >
                <g
                  id="illu_battery_outline_white"
                  transform="translate(3363.000000, 995.000000)"
                  stroke="currentColor"
                  stroke-width="3"
                >
                  <path
                    d="M65.6907854,1.5 L34.3078922,1.5 L34.3078922,14.8859781 L13.0297941,14.8859781 C6.68267167,14.8859781 1.5,20.3963716 1.5,27.240135 L1.5,226.147249 C1.5,232.988903 6.68333284,238.5 13.0297941,238.5 L86.9702059,238.5 C93.3166672,238.5 98.5,232.988903 98.5,226.147249 L98.5,27.240135 C98.5,20.3963716 93.3173283,14.8859781 86.9702059,14.8859781 L65.6907854,14.8859781 L65.6907854,1.5 Z"
                    id="battery_top"
                  ></path>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <swiper-container pagination="true" loop="true">
          @if (showConsumptionSlide) {
            <swiper-slide>
              <ec-charge-session-status-slide-power
                [powerValue]="chargingSession?.consumption || 0"
              ></ec-charge-session-status-slide-power>
            </swiper-slide>
          }
          <swiper-slide>
            <ec-charge-session-status-slide-duration
              [duration]="chargingSession?.duration || '0:00:00'"
            >
            </ec-charge-session-status-slide-duration>
          </swiper-slide>
          <swiper-slide>
            <ec-charge-session-status-slide-location
              [chargePoint]="chargePoint?.name || ''"
              [address]="
                stationData
                  ? stationData.address?.street +
                    ', ' +
                    stationData.address?.zipCode +
                    ' ' +
                    stationData.address?.city
                  : ''
              "
            >
            </ec-charge-session-status-slide-location>
          </swiper-slide>
        </swiper-container>
        <div class="charging-stop-buttons">
          @if (sessionStopFailed$()) {
            <button class="button-filled-secondary" (click)="clearSession()">
              {{ 'session.close' | translate }}
            </button>
          }
          <button class="button-filled-primary" (click)="stopCharging()">
            <eop-icon identifier="stop" class="stop" aria-hidden="true"></eop-icon>
            {{ 'session.stop' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
}

@if (chargingSession && chargingSession.terminated) {
  <dialog
    class="overlay summary"
    aria-modal="true"
    [attr.aria-label]="'session.a11y.summary-title' | translate"
  >
    <app-summary
      [session]="chargingSession"
      [chargePoint]="chargePoint"
      [station]="stationData"
      [tariff]="tariff"
      (closed)="clearSession()"
    ></app-summary>
  </dialog>
}
